import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    GET_PLAYER_REPORT,
    GET_PLAYER_REPORT_BY_TIME
} from "../constants/ActionTypes";
import {
    getPlayerReportSuccess,
    getPlayerReportError,
    getPlayerReportByTimeSuccess,
    getPlayerReportByTimeError
} from "../actions/PlayerReportAction";
import { userSignOut } from '../actions/Auth'
import { getPlayerReportApi, getPlayerReportByTimeApi } from "../api/PlayerReportApi";

function* getPlayerReportRequest({ payload }) {
    try {
        const playerReport = yield call(getPlayerReportApi, payload);
        if (playerReport.code) {
            if (playerReport.code === 401) {
                yield put(userSignOut());
            } else {
                yield put(getPlayerReportError(playerReport));
            }
        } else {
            yield put(getPlayerReportSuccess(playerReport));
        }
    } catch (error) {
        yield put(getPlayerReportError(error));
    }
}
function* getPlayerReportByTimeRequest({ payload }) {
    try {
        const playerReport = yield call(getPlayerReportByTimeApi, payload);
        if (playerReport.code) {
            yield put(getPlayerReportByTimeError(playerReport));
        } else {
            yield put(getPlayerReportByTimeSuccess(playerReport));
        }
    } catch (error) {
        yield put(getPlayerReportByTimeError(error));
    }
}

export function* getPlayerReport() {
    yield takeEvery(GET_PLAYER_REPORT, getPlayerReportRequest);
}
export function* getPlayerReportByTime() {
    yield takeEvery(GET_PLAYER_REPORT_BY_TIME, getPlayerReportByTimeRequest);
}

export default function* rootSaga() {
    yield all([fork(getPlayerReport),
    fork(getPlayerReportByTime)
    ]);
}